import { addMonths as a } from "./addMonths.js";
function o(r, t) {
  return a(r, t * 12);
}
export {
  o as addYears,
  o as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/addYears.js
// module id = 881
// module chunks = 67